<template>
  <div class="px-6">
    <section class="module-default mx-auto max-w-[75rem]">
      <h2
        class="mb-6 text-2xl font-medium text-primary-blue md:mb-8 md:max-w-[75%] md:text-4xl"
      >
        {{ translations.you_might_also_be_interested_in }}
      </h2>

      <ul class="grid grid-cols-1 gap-9 md:grid-cols-2">
        <li
          v-for="article in newsArticles"
          :key="article.id"
          class="flex justify-center"
        >
          <!-- NEWS CARD -->
          <NewsCard :article="article" />
        </li>
      </ul>
    </section>
  </div>
</template>

<script setup>
import { store } from '/store.js'
const { locale } = useI18n()

const translations = computed(() => store.translations)

const newsArticles = ref([])

const { data } = await useAsyncGql({
  operation: 'NewsArticlesTeaser',
  variables: {
    filter: {
      site: locale,
      id: { not: store.pageId },
    },
  },
})
const payload = data.value
if (!payload) {
  console.error('NewsArticlesTeaser could not be fetched')
}
newsArticles.value.push(data.value.newest?.data[0])
newsArticles.value.push(data.value.random?.data[0])
</script>
